<h2 mat-dialog-title class="flex items-center gap-2">
    <mat-icon>{{ deviceTypeIcon }}</mat-icon>
    Assign Existing {{ deviceTypeLabel }}
</h2>

<mat-dialog-content class="assign-dialog-content">
    @if (isLoading()) {
    <div class="flex justify-center items-center py-8">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
    }

    @if (!isLoading() && availableDevices().length === 0) {
    <div class="text-center py-6 text-gray-500">
        <mat-icon class="text-5xl opacity-40">{{ deviceTypeIcon }}</mat-icon>
        <p class="mt-2">No available {{ deviceTypeLabel | lowercase }}s found in other device groups within this zone.
        </p>
    </div>
    }

    @if (!isLoading() && availableDevices().length > 0) {
    <p class="text-sm text-gray-600 mb-3">
        Select a {{ deviceTypeLabel | lowercase }} from another device group to assign to this group.
    </p>
    <mat-selection-list [multiple]="false" class="device-selection-list">
        @for (device of availableDevices(); track device.id) {
        <mat-list-option [value]="device" [selected]="isSelected(device)" (click)="selectDevice(device)">
            <mat-icon matListItemIcon>{{ deviceTypeIcon }}</mat-icon>
            <span matListItemTitle>{{ device.name }}</span>
            <span matListItemLine class="text-gray-500 text-xs">Group: {{ device.deviceGroupName }}</span>
        </mat-list-option>
        @if (!$last) {
        <mat-divider></mat-divider>
        }
        }
    </mat-selection-list>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!selectedDevice()" (click)="confirm()">
        <mat-icon>link</mat-icon>
        Assign
    </button>
</mat-dialog-actions>